export default __webpack_public_path__ + "static/10-9aa232183abbaa5021b3e30f6cf6ac21.png";